import { AsyncJobProcessTypeEnum } from '../../types/asyncExport.types';

type Module = string;

export const getAsyncExportProcessType = (
	module: Module,
	exportAll?: boolean,
	params?: Record<string, unknown>
): AsyncJobProcessTypeEnum | null => {
	if (!exportAll) {
		return null;
	}

	const moduleLower = module.toLowerCase();

	if (
		moduleLower.includes('restricted') ||
		moduleLower.includes('restrito')
	) {
		return AsyncJobProcessTypeEnum.EXPORT_RESTRICTED_PLAN;
	}

	if (moduleLower.includes('consensus') || moduleLower.includes('consenso')) {
		return AsyncJobProcessTypeEnum.EXPORT_CONSENSUS;
	}

	if (
		moduleLower.includes('collaboration') ||
		moduleLower.includes('colaboracao')
	) {
		if (params?.collaboration_type) {
			const collabType = params.collaboration_type as string;
			if (collabType === 'planning') {
				return AsyncJobProcessTypeEnum.EXPORT_PLANNING_COLLAB;
			}
			if (collabType === 'marketing') {
				return AsyncJobProcessTypeEnum.EXPORT_MARKETING_COLLAB;
			}
			if (collabType === 'commercial') {
				return AsyncJobProcessTypeEnum.EXPORT_COMMERCIAL_COLLAB;
			}
		}

		if (
			moduleLower.includes('planning') ||
			moduleLower.includes('planejamento')
		) {
			return AsyncJobProcessTypeEnum.EXPORT_PLANNING_COLLAB;
		}
		if (moduleLower.includes('marketing')) {
			return AsyncJobProcessTypeEnum.EXPORT_MARKETING_COLLAB;
		}
		if (
			moduleLower.includes('commercial') ||
			moduleLower.includes('comercial')
		) {
			return AsyncJobProcessTypeEnum.EXPORT_COMMERCIAL_COLLAB;
		}

		return AsyncJobProcessTypeEnum.EXPORT_PLANNING_COLLAB;
	}

	return null;
};

export const getCollaborationTypeFromProcessType = (
	processType: AsyncJobProcessTypeEnum
): 'planning' | 'marketing' | 'commercial' | undefined => {
	switch (processType) {
		case AsyncJobProcessTypeEnum.EXPORT_PLANNING_COLLAB:
			return 'planning';
		case AsyncJobProcessTypeEnum.EXPORT_MARKETING_COLLAB:
			return 'marketing';
		case AsyncJobProcessTypeEnum.EXPORT_COMMERCIAL_COLLAB:
			return 'commercial';
		default:
			return undefined;
	}
};
